import { retrieveProductTechnology } from '@vfit/consumer/data-access';
import { setTrackLink, setTrackView, useTracking } from '@vfit/shared/data-access';
import { removeCurrency } from '@vfit/consumer/hooks';
import { useQueryClient } from 'react-query';
import { SoftManagerService } from '@vfit/consumer/providers';
import { useCoverageToolModalProvider } from '../../coverageToolModal.context';

const CoverageToolChooseContactTagging = () => {
  const { product } = useCoverageToolModalProvider();
  const queryClient = useQueryClient();

  const pageProduct = {
    product_category: 'fixed',
    product_id: `${product?.offerId}`,
    product_name: product?.slug,
    product_price: product?.price && removeCurrency(product.price),
    product_quantity: '1',
  };

  const opts = {
    event_category: 'journey',
    page_subsection: 'lock-in verify id',
    page_section: 'fixed offers',
    page_type: 'verify id',
    journey_name: 'verify lock-in',
    product_technology: retrieveProductTechnology(),
  };

  const { trackView } = useTracking({
    event: ['journey'],
    event_label: 'verify id',
    opts,
    pageProduct,
    visitorTrackingOpts: SoftManagerService(queryClient).getUser(),
  });

  setTrackLink(trackView);
  setTrackView(trackView);
  return null;
};

export default CoverageToolChooseContactTagging;
